export function isMobile(): boolean {
  return /Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  ) || (navigator.maxTouchPoints > 0 && window.innerWidth < 1024);
}

export function getGPUTier(): 'low' | 'mid' | 'high' {
  const canvas = document.createElement('canvas');
  const gl = canvas.getContext('webgl2') || canvas.getContext('webgl');
  if (!gl) return 'low';

  const ext = (gl as WebGLRenderingContext).getExtension('WEBGL_debug_renderer_info');
  if (!ext) return 'mid';

  const renderer = (gl as WebGLRenderingContext).getParameter(ext.UNMASKED_RENDERER_WEBGL).toLowerCase();
  canvas.remove();

  if (/apple gpu|mali-4|adreno 3|powervr/.test(renderer)) return 'low';
  if (/nvidia|radeon|geforce|rtx|gtx/.test(renderer)) return 'high';
  return 'mid';
}
